import React, {useEffect, useMemo, useState} from "react";
import {Checkbox, Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import TextFieldValidation from "../table/customer-detales/TextFieldValidation";
import ButtonExit from "../button/ButtonExit";
import ButtonAdd from "../button/ButtonAdd";
import MenuItem from "@mui/material/MenuItem";
import ModulesTable from "../../../pages/common/settings/ModulesTable";
import ModuleController from "../../../API/organization/ModuleController";
import {EditLocalStoragePagesData} from "../../../utils/EditLocalStoragePagesData";
import {Box} from "@mui/system";
import {withFilter} from "../../../data/FilterTables/withFilterHOC";
import {ModulesFilterData} from "../../../data/FilterTables/ModulesFilterData";
import FormControlLabel from "@mui/material/FormControlLabel";

const initValidation = {
    "name": "",
}
const ModalModule = ({
                         open,
                         onClose,
                         handleSubmit,
                         initValue,
                         title,
                         loading,
                         cornerTypeModuleList,
                         typeCompositionModuleList,
                         handleModalAlert
                     }) => {
    const [formState, setFormState] = useState(initValue)
    const [validationState, setValidationState] = useState(initValidation)

    useEffect(() => {
        setFormState(initValue)
    }, [initValue])

    const handleClose = () => {
        setFormState(initValue)
        onClose()
        setValidationState(initValidation)
    }

    const handleValidationData = () => {
        const newErrors = {...validationState}

        Object.entries(formState).forEach(([name, value]) => {

            if (value === "" && name === "name") {
                newErrors[name] = "пустое поле"
            }
        })

        setValidationState(newErrors)

        if (Object.values(newErrors).every(el => el === "")) {
            handleSubmit(formState, handleClose)
        }
    }
    return (
        <Dialog open={open} PaperProps={{
            style: {
                minWidth: "800px",
                borderRadius: 8,
            }
        }}>
            <DialogTitle textAlign="center">{title}</DialogTitle>
            <DialogContent sx={{display: "flex", justifyContent: "space-between"}}>
                <Box sx={{width: 370}}>
                    <TextFieldValidation
                        name={"name"}
                        type={"text"}
                        value={formState?.name}
                        label={"Наименование"}
                        setCurrValues={setFormState}
                        validationError={validationState?.name}
                        setValidationState={setValidationState}
                    />
                    <TextFieldValidation
                        name={"shortDescription"}
                        type={"text"}
                        value={formState?.shortDescription}
                        label={"Описание"}
                        setCurrValues={setFormState}
                        required={false}
                    />

                    <TextFieldValidation
                        select
                        label="Тип композиции"
                        value={formState?.typeComposition}
                        setCurrValues={(getData) => setFormState(prev => ({
                            ...prev,
                            typeComposition: getData()
                        }))}
                        width={"370px"}
                        required={false}
                    >
                        {typeCompositionModuleList?.map((option) => (
                            <MenuItem key={option[0]} value={option[0]}>
                                {option[1]}
                            </MenuItem>
                        ))}
                    </TextFieldValidation>
                    <TextFieldValidation
                        select
                        label="Тип кухни по расположению"
                        value={formState?.cornerType}
                        setCurrValues={(getData) => setFormState(prev => ({
                            ...prev,
                            cornerType: getData()
                        }))}
                        width={"370px"}
                        required={false}
                        disabled={formState?.typeComposition !== "KITCHEN"}
                    >
                        {cornerTypeModuleList?.map((option) => (
                            <MenuItem key={option[0]} value={option[0]}>
                                {option[1]}
                            </MenuItem>
                        ))}
                    </TextFieldValidation>
                    <TextFieldValidation
                        name={"collection"}
                        value={formState?.collection}
                        label={"Коллекция"}
                        setCurrValues={setFormState}
                        required={false}
                    />
                    <TextFieldValidation
                        name={"colorScheme"}
                        value={formState?.colorScheme}
                        label={"Название расцветки"}
                        setCurrValues={setFormState}
                        required={false}
                    />
                    <TextFieldValidation
                        name={"typeWallPanel"}
                        value={formState?.typeWallPanel}
                        label={"Тип стеновой панели"}
                        setCurrValues={setFormState}
                        required={false}
                    />
                    <TextFieldValidation
                        name={"nameShortWallPanel"}
                        value={formState?.nameShortWallPanel}
                        label={"Наименование стеновой панели"}
                        setCurrValues={setFormState}
                        required={false}
                    />
                    <TextFieldValidation
                        name={"price"}
                        type={"number"}
                        value={formState?.price}
                        label={"Цена"}
                        setCurrValues={setFormState}
                        validationError={validationState?.price}
                        setValidationState={setValidationState}
                        required={false}
                    />
                    <TextFieldValidation
                        name={"alternativePrice"}
                        type={"number"}
                        value={formState?.alternativePrice}
                        label={"Цена в альтернативной валюте"}
                        setCurrValues={setFormState}
                        validationError={validationState?.alternativePrice}
                        setValidationState={setValidationState}
                        required={false}
                    />
                    <FormControlLabel control={<Checkbox
                        checked={formState?.top}
                        onChange={() => setFormState(value => ({
                            ...value,
                            "top": !value.top
                        }))}
                        sx={{marginLeft: "20px"}}
                    />} label="Популярное"/>
                    <FormControlLabel control={<Checkbox
                        checked={formState?.discount}
                        onChange={() => setFormState(value => ({
                            ...value,
                            "discount": !value.discount
                        }))}
                        sx={{marginLeft: "20px"}}
                    />} label="Скидка"/>
                    <TextFieldValidation
                        name={"discountAmount"}
                        type={"number"}
                        value={formState?.discountAmount}
                        label={"Сумма скидки"}
                        setCurrValues={setFormState}
                        validationError={validationState?.discountAmount}
                        setValidationState={setValidationState}
                        disabled={!formState?.discount}
                    />
                </Box>
                <Box sx={{width: 370}}>
                    <TextFieldValidation
                        name={"typeBodyTop"}
                        value={formState?.typeBodyTop}
                        label={"Тип верха корпуса"}
                        setCurrValues={setFormState}
                        required={false}
                    />
                    <TextFieldValidation
                        name={"nameShortBodyTop"}
                        value={formState?.nameShortBodyTop}
                        label={"Наименование верха корпуса"}
                        setCurrValues={setFormState}
                        required={false}
                    />
                    <TextFieldValidation
                        name={"typeBodyBottom"}
                        value={formState?.typeBodyBottom}
                        label={"Тип низа корпуса"}
                        setCurrValues={setFormState}
                        required={false}
                    />
                    <TextFieldValidation
                        name={"nameShortBodyBottom"}
                        value={formState?.nameShortBodyBottom}
                        label={"Наименование низа корпуса"}
                        setCurrValues={setFormState}
                        required={false}
                    />
                    <TextFieldValidation
                        name={"typeFrontTop"}
                        value={formState?.typeFrontTop}
                        label={"Тип верха фасада"}
                        setCurrValues={setFormState}
                        required={false}
                    />
                    <TextFieldValidation
                        name={"nameShortFrontTop"}
                        value={formState?.nameShortFrontTop}
                        label={"Наименование верха фасада"}
                        setCurrValues={setFormState}
                        required={false}
                    />
                    <TextFieldValidation
                        name={"typeFrontBottom"}
                        value={formState?.typeFrontBottom}
                        label={"Тип низа фасада"}
                        setCurrValues={setFormState}
                        required={false}
                    />
                    <TextFieldValidation
                        name={"nameShortFrontBottom"}
                        value={formState?.nameShortFrontBottom}
                        label={"Наименование низа фасада"}
                        setCurrValues={setFormState}
                        required={false}
                    />
                    <TextFieldValidation
                        name={"typeTableTop"}
                        value={formState?.typeTableTop}
                        label={"Тип верха столешницы"}
                        setCurrValues={setFormState}
                        required={false}
                    />
                    <TextFieldValidation
                        name={"nameShortTableTop"}
                        value={formState?.nameShortTableTop}
                        label={"Наименование верха столешницы"}
                        setCurrValues={setFormState}
                        required={false}
                    />
                    <TextFieldValidation
                        name={"countertopCuttingTreatment"}
                        value={formState?.countertopCuttingTreatment}
                        label={"Обработка среза столешницы"}
                        setCurrValues={setFormState}
                        required={false}
                    />
                </Box>
            </DialogContent>
            <DialogActions sx={{p: '1.25rem'}}>
                <ButtonExit text={"Отменить"} onClick={handleClose}/>
                <ButtonAdd loading={loading} text={initValue?.id ? "Изменить" : "Добавить"}
                           onClick={handleValidationData}/>
            </DialogActions>
        </Dialog>
    );
}
export default ModalModule
